'use client';

import * as a from "react";
import p from "../lib/IconBase.es.js";
import e from "../defs/FileZip.es.js";
const o = a.forwardRef((i, r) => /* @__PURE__ */ a.createElement(p, { ref: r, ...i, weights: e }));
o.displayName = "FileZipIcon";
const c = o;
export {
  c as FileZip,
  o as FileZipIcon
};
